/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_More_Stats_Add_WeightInputs */

const en_ui_more_stats_add_weight = /** @type {(inputs: Ui_More_Stats_Add_WeightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add your weight`)
};

const de_ui_more_stats_add_weight = /** @type {(inputs: Ui_More_Stats_Add_WeightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gewicht eintragen`)
};

/**
* | output |
* | --- |
* | "Add your weight" |
*
* @param {Ui_More_Stats_Add_WeightInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_more_stats_add_weight = /** @type {((inputs?: Ui_More_Stats_Add_WeightInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_More_Stats_Add_WeightInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_more_stats_add_weight(inputs)
	return de_ui_more_stats_add_weight(inputs)
});